import { ACTION_TYPE } from '../actions/actionTypes';

const assetAllocations = (state = [], action) => {
  switch (action.type) {
    case ACTION_TYPE.SAVE_ASSET_ALLOCATION:
      return {
        ...state,
        assetAllocation: action.payload.assetAllocation,
        assetAllocationDetails: action.payload.assetAllocationDetails,
        isinCodes: action.payload.isinCodes,
        tacticleAsset: action.payload.tacticleAsset,
      };
    default:
      return state;
  }
};

export default assetAllocations;
